import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress PostHog/analytics errors that are not from app code
window.addEventListener('error', (event) => {
  if (event.message && (
    event.message.includes('postMessage') ||
    event.message.includes('PerformanceServerTiming') ||
    event.message.includes('posthog')
  )) {
    event.preventDefault();
    event.stopPropagation();
    return true;
  }
});

// Also suppress unhandled promise rejections from analytics
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason && event.reason.message && (
    event.reason.message.includes('postMessage') ||
    event.reason.message.includes('PerformanceServerTiming') ||
    event.reason.message.includes('posthog')
  )) {
    event.preventDefault();
    event.stopPropagation();
    return true;
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
